import config from "../config/app.conf.json";

export default () => ({
  url: config.tnc.getlatestTnc,
  method: "GET"
});
